export const contacts = () => {
  if (document.querySelector('.contacts')) {
    const fileInput = document.querySelector('input[type="file"][name="your-file"]');
    const fileLabel = fileInput.closest('.input-file').querySelector('.body-14-r');
    const fileLabelDefault = fileLabel.textContent;

    fileInput.addEventListener('change', () => {
      if (fileInput.files.length > 0) {
        fileLabel.textContent = fileInput.files[0].name;
      } else {
        fileLabel.textContent = fileLabelDefault;
      }
    });


    document.querySelector('.contacts form').addEventListener( 'wpcf7mailsent', function( event ) {
      document.querySelector('.contacts__right').classList.add('active')

      setTimeout(function () {
        document.querySelector('.contacts__right').classList.remove('active')
      }, 5000)
    }, false );
  }


}